import { useEffect } from 'react';

import { trackMenuBuildCompleted } from 'helpers/menuUploadAnalytics';

import { loadMenuBuildFromStorage, saveMenuBuildToStorage } from './menuBuildStorage';
import type { BuildStatusResponse } from './types';

type UseReportMenuBuildOutcomeParams = {
  buildStatusData: BuildStatusResponse | null;
  jobId: string | null;
  /** Set by surfaces outside Menu Management so their builds can be told apart. */
  source?: string;
};

/** Tracks how a build ended, once per build, however often the page is reloaded. */
export const useReportMenuBuildOutcome = ({
  buildStatusData,
  jobId,
  source,
}: UseReportMenuBuildOutcomeParams) => {
  useEffect(() => {
    const status = buildStatusData?.status;
    if (!jobId || !status) return;

    const isFailed = status === 'failed';
    const isComplete = status === 'menu_inserted' || status === 'finished';
    if (!isFailed && !isComplete) return;

    const stored = loadMenuBuildFromStorage();
    if (stored?.reported) return;

    if (stored) saveMenuBuildToStorage({ ...stored, reported: true });
    trackMenuBuildCompleted({
      errorKey: isFailed ? buildStatusData.errorKey : undefined,
      jobId,
      outcome: isFailed ? 'failed' : 'success',
      source,
    });
  }, [jobId, buildStatusData, source]);
};
